module.exports = __webpack_public_path__ + "img/update-icon.e9f96db3.svg";